import { useQuery } from "@obvio/app";

import type { Schema } from "@obvio/app";
import type { DeepPick } from "@obvio/utils";

export const ARTICLE_ALL_SELECT = {
  id: true,
  createdAt: true,
  slug: true,
  title: true,
  image: true,
  content: true,
  seoDescription: true,
  category: {
    title: true,
  },
} as const;

export type ARTICLE_DATA = DeepPick<
  Schema["Article"],
  typeof ARTICLE_ALL_SELECT
>;

type query = typeof useQuery<
  "getArticles",
  typeof ARTICLE_ALL_SELECT,
  { select: typeof ARTICLE_ALL_SELECT; args: { category?: string } }
  >;

export function useArticlesAll(category?: string): ReturnType<query> {
  return useQuery("getArticles", {
    select: ARTICLE_ALL_SELECT,
    ...(category
      ? {
        args: {
          category,
        },
      }
      : {}),
  });
}
